import { Result } from '@hereisyourgitanton/core';
import { Observable, map } from 'rxjs';
import { TradingCommandPort, Id, SetAutoBidPayload, AutoBid, CreateBidPayload } from '@tradgine/application-english-auction-trade';
import { inject } from '@angular/core';
import { BidAuctionApi } from '@tradgine/data-access/auction-flow';
import { AutoBidInstructionsApi } from '@tradgine/data-access/auto-bid';
import { toAutoBid } from '../mappers/mappers';

export class TradingCommandAdapter implements TradingCommandPort {
    private readonly bidApiService = inject(BidAuctionApi);
    private readonly autoBidApiService = inject(AutoBidInstructionsApi);

    createBid(payload: CreateBidPayload): Observable<Result<void, Error>> {
        return this.bidApiService
            .createBid(payload)
            .pipe(map((result) => result.map(() => void 0).mapErr(() => new Error('Failed to create bid'))));
    }

    setAutoBid(payload: SetAutoBidPayload): Observable<Result<AutoBid, Error>> {
        return this.autoBidApiService
            .configure(payload)
            .pipe(map((result) =>
                result
                    .map((autobidDto) => toAutoBid(autobidDto))
                    .mapErr(() => new Error('Failed to create autoBid'))));
    }

    removeAutoBid(auctionId: Id): Observable<Result<void, Error>> {
        return this.autoBidApiService.delete(auctionId).pipe(
            map((result) => result.map(() => void 0).mapErr(() => new Error('Failed to remove auto bid')))
        )
    }
}
